import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminBulkPreview from '../AdminBulkPreview.js';

const BulkDeleteUserModal = ({ isOpen, onClose, onConfirm, users, loading }) => (
  <AdminModal
    isOpen={isOpen && users?.length > 0}
    onClose={onClose}
    title="Delete Users"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete All Users'}
        </button>
      </>
    )}
  >
    <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
      Are you sure you want to delete {users?.length} user{users?.length > 1 ? 's' : ''}? This action cannot be undone.
    </p>
    <AdminBulkPreview
      items={users || []}
      getKey={(user) => user.userId}
      getName={(user) => user.name}
      getMeta={(user) => user.email}
      noun="user"
    />
    <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
      All selected users will lose access to the system and their data will be removed.
    </p>
  </AdminModal>
);

export default BulkDeleteUserModal;
